import { ErrorPage, ErrorPageType } from '@exam-management/components';
import { APP_PERMISSIONS } from '@exam-management/permissions';
import { QBankStructureCVModalProvider } from '@exam-management/qbank-structure-cv';
import { useQBankStructure } from '@exam-management/qbs-provider';
import { PermissionGuard } from '@shared/permissions';
import { Outlet } from 'react-router-dom';

export default function QBankStructureSettingLayout() {
  const { pageAccessibility } = useQBankStructure();

  if (!pageAccessibility.settings) {
    return <ErrorPage errorType={ErrorPageType.NO_PERMISSION} />;
  }

  return (
    <PermissionGuard requiredPermission={APP_PERMISSIONS.QBANK.SETTING.VIEW}>
      <QBankStructureCVModalProvider>
        <Outlet />
      </QBankStructureCVModalProvider>
    </PermissionGuard>
  );
}
